export default {
  'footer.copyright': '© 2024–2026 Keitaro Shimizu - All rights reserved',
};
